{
	"title": "{{plant}} {{year}} – Adjust carbon account settings",
	"description": "You can change the carbon origin proportion (% of fossil / % of biogenic) or/end EAC value, but the change will take effect from the next opportunity. You can add a reason for the change, which will be visible in the change log below.",
	"currentProportionTitle": "Current carbon origin proportion",
	"fossil": "Fossil",
	"biogenic": "Biogenic",
	"eac": "EAC",
	"decreaseValue": "Decrease {{field}}",
	"increaseValue": "Increase {{field}}",
	"reasonForAdjustment": "Reason for adjustment",
	"reasonHint": "Please describe the reason for the adjustment.",
	"changeLogTitle": "Carbon origin proportion change log ({{year}})",
	"editor": "Editor",
	"warning": "During the annual assurance process, the assurance body will review all balance adjustments. Prior to making any adjustments, it is mandatory to contact the assurance body to discuss the proposed changes.",
	"closeWarning": "Close warning",
	"confirmLabel": "I confirm the carbon origin proportion adjustment.",
	"footerHint": "Change the carbon origin proportion volume, fill in the reason, and toggle confirmation to adjust the buffer volume.",
	"cancel": "Cancel",
	"submit": "Adjust carbon origin proportion",
	"fetchError": "Could not load the carbon account settings. Please try again.",
	"submitSuccess": "Carbon account settings adjusted successfully.",
	"submitError": "Could not adjust the carbon account settings. Please try again."
}
